import client from '../client'

export async function changeDetails({ firstName, lastName, phoneNumber, zipCode }) {
  return client(
    `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/${process.env.NEXT_PUBLIC_IDENTITY_VERSION}/user/changedetails`,
    {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({ firstName, lastName, phoneNumber, zipCode }),
    },
  )
}
